var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-header"},[_c('span',{staticClass:"header_title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.isMore)?_c('span',{staticClass:"more",on:{"click":_vm.checkMore}},[_c('span',[_vm._v("更多数据")]),_vm._v(" "),_c('img',{attrs:{"src":require("./img/more.png")}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ad375e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/spacerBar/commonHeader.vue
// module id = null
// module chunks = 